"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _Checkbox = _interopRequireDefault(require("./Checkbox"));
var _TextField = _interopRequireDefault(require("./TextField"));
var _excluded = ["name", "id", "label", "value", "setFieldValue", "fullWidth", "options", "activeColor", "InputProps", "optionType", "sx"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var MultiSelect = function MultiSelect(_ref) {
  var name = _ref.name,
    id = _ref.id,
    label = _ref.label,
    value = _ref.value,
    setFieldValue = _ref.setFieldValue,
    fullWidth = _ref.fullWidth,
    options = _ref.options,
    activeColor = _ref.activeColor,
    InputProps = _ref.InputProps,
    optionType = _ref.optionType,
    sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded);
  var onChange = function onChange(e, newValue) {
    setFieldValue(name, newValue);
  };
  var renderOption = {
    checkbox: function checkbox(optionProps, option, _ref2) {
      var selected = _ref2.selected;
      return /*#__PURE__*/_react["default"].createElement(_material.Box, {
        my: -1,
        onClick: function onClick(e) {
          return e.preventDefault();
        }
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], _extends({
        label: option.title,
        checked: selected,
        activeColor: activeColor
      }, optionProps)));
    },
    option: function option(optionProps, _option) {
      return /*#__PURE__*/_react["default"].createElement(_material.ListItem, _extends({
        onClick: function onClick(e) {
          return e.preventDefault();
        }
      }, optionProps), _option.title);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], _extends({
    multiple: true,
    limitTags: 3,
    fullWidth: fullWidth,
    id: id,
    name: name,
    disableCloseOnSelect: true,
    options: options,
    getOptionLabel: function getOptionLabel(option) {
      return option.title;
    },
    isOptionEqualToValue: function isOptionEqualToValue(option, svalue) {
      return option.value === svalue.value;
    },
    getLimitTagsText: function getLimitTagsText(more) {
      return /*#__PURE__*/_react["default"].createElement(_material.Chip, {
        color: "primary",
        label: "+".concat(more),
        size: "small"
      });
    },
    onChange: onChange,
    renderOption: renderOption[optionType],
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({}, params, {
        variant: "filled",
        label: label,
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), InputProps)
      }));
    },
    renderTags: function renderTags(a, getTagProps) {
      return value.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement(_material.Chip, _extends({
          key: option.value,
          color: "primary",
          size: "small",
          label: option.title,
          style: {
            marginTop: '.5rem'
          }
        }, getTagProps({
          index: index
        })));
      });
    },
    value: value,
    sx: sx
  }, props));
};
MultiSelect.propTypes = {
  id: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  setFieldValue: _propTypes["default"].func.isRequired,
  activeColor: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  value: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  optionType: _propTypes["default"].oneOf(['checkbox', 'option']),
  sx: _propTypes["default"].shape({})
};
MultiSelect.defaultProps = {
  activeColor: '#000',
  value: [],
  fullWidth: false,
  options: [],
  optionType: 'checkbox',
  sx: {}
};
var _default = exports["default"] = MultiSelect;